import { Component } from "@/types/types"
import { cx } from "@/utils/cx"

import { Link } from "../Link"

export const COMPONENT_NAME = "styledLink"

export const presets = {}

export interface Props extends Component {
  onClick: () => void
}

export function TextButton({ onClick, children, className, testId = COMPONENT_NAME }: Props) {
  return (
    <button
      onClick={onClick}
      className={cx(
        `font-semibold leading-none focus:outline-none focus-ring rounded-sm`,
        className,
      )}
      data-test={testId}
    >
      {children}
    </button>
  )
}
